import {FormEvent, useState} from "react";
import {Card, Form} from "react-bootstrap";
import {Link, Navigate, useSearchParams} from "react-router";
import {useAuth} from "../auth/AuthContext";
import {ErrorAlert} from "../components/ErrorAlert";
import {SubmitButton} from "../components/SubmitButton";

// Only paths on this site, so a crafted link can't send people elsewhere after signing in.
function safeReturnTo(value: string | null): string {
    return value && value.startsWith('/') && !value.startsWith('//') ? value : '/account/profile';
}

// The one sign-in screen, for the account pages and the administration area alike.
export function LoginPage() {
    const {user, login} = useAuth();
    const [params] = useSearchParams();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<unknown>();

    if (user) {
        return <Navigate to={safeReturnTo(params.get('returnTo'))} replace/>;
    }

    const submit = async (e: FormEvent) => {
        e.preventDefault();
        setBusy(true);
        setError(undefined);
        try {
            await login(username.trim(), password);
        } catch (err) {
            setError(err);
            setBusy(false);
        }
    };

    return (
        <Card className="auth-card mx-auto mt-md-4">
            <Card.Body className="p-4">
                <h1 className="h4 mb-4">Sign in</h1>
                <ErrorAlert error={error} messages={{ 400: 'Incorrect username or password, or the account is disabled.' }}/>
                <Form onSubmit={submit}>
                    <Form.Group className="mb-3" controlId="username">
                        <Form.Label>Username</Form.Label>
                        <Form.Control autoComplete="username" autoFocus required value={username} onChange={e => setUsername(e.target.value)}/>
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)}/>
                    </Form.Group>
                    <SubmitButton busy={busy} className="w-100">Sign in</SubmitButton>
                </Form>
                <div className="text-center mt-3">
                    <Link to="/forgot-password" className="small">Forgot your password?</Link>
                </div>
            </Card.Body>
        </Card>
    );
}
